import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import MainLayout from '../layouts/MainLayout';
import MessagesTable from '../components/MessagesTable';
import MessagesPagination from '../components/ClientPagination';
import useApi from '../utils/useApi';
import { useLoading } from '../context/LoadingContext';
import { Modal } from 'bootstrap';
import ConfirmPasswordModal from '../components/ConfirmPasswordModal';
import EmailLayout from '../components/EmailLayout'; // Import the new EmailLayout component

const BrowseMessages = () => {
  const { callApi } = useApi();
  const { setLoading } = useLoading();
  const [messages, setMessages] = useState([]);
  const [selectedMessages, setSelectedMessages] = useState([]); // Track selected messages
  const [searchQuery, setSearchQuery] = useState('');
  const [searchLetter, setSearchLetter] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const messagesPerPage = parseInt(process.env.REACT_APP_MESSAGES_PER_PAGE) || 25;
  const [totalMessages, setTotalMessages] = useState(0);
  const [messageDetail, setMessageDetail] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);
  const [typingTimeout, setTypingTimeout] = useState(null);

  // Fetch messages
  const fetchMessages = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        length: messagesPerPage,
        keyword: debouncedSearchQuery || undefined,
        startsWith: searchLetter !== 'All' ? searchLetter : undefined,
      };

      const response = await callApi({
        endpoint: '/admin/email-messages/get-all-messages',
        params,
      });

      setMessages(response.data.messages || []);
      setTotalMessages(response.data.totalMessages || 0);
    } catch (error) {
      console.error('Error fetching messages:', error);
    } finally {
      setLoading(false);
    }
  };

  // Debounced search
  useEffect(() => {
    if (typingTimeout) clearTimeout(typingTimeout);
    setTypingTimeout(
      setTimeout(() => {
        setDebouncedSearchQuery(searchQuery); // Apply search query
      }, 500) // Wait 500ms after typing stops
    );
  }, [searchQuery]);

  // Fetch messages whenever the search query, currentPage or searchLetter change
  useEffect(() => {
    fetchMessages();
  }, [currentPage, debouncedSearchQuery, searchLetter]);

  // View message details with header and footer
  const viewDetails = (message) => {
    setMessageDetail(message); // Display message content in modal
    const modalElement = document.getElementById('messageDetailsModal');
    const modalInstance = new Modal(modalElement);
    modalInstance.show();
  };

  return (
    <MainLayout>
      <div className="inner_full_right_part">
        <div className="row">
          <div className="col-md-12">
            <div className="global_cardbox">
              {/* Other code for header, filters, etc. */}
              <div className="global_card_header">
                <div className="row">
                  <div className="col-md-3">
                    <div className="global_head_tag">
                      <span><i className="fa-solid fa-folder-open"></i></span> Search Users<em></em>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="heading_block">
                    <input
                        type="text"
                        name="fakeusernameremembered"
                        style={{ display: "none" }}
                        autoComplete="username"
                        tabIndex={-1}
                      />
                      <input
                        type="search"
                        placeholder="Search User"
                         autoComplete="abcd"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)} // Bind input to searchQuery state
                      />
                    </div>
                  </div>
                </div>
              </div>
              <MessagesTable
                messages={messages}
                selectedUsers={selectedMessages}
                toggleUserSelection={() => {}}
                toggleSelectAll={() => {}}
                viewDetails={viewDetails}
                deleteClient={() => {}}
              />
              <MessagesPagination
                currentPage={currentPage}
                totalPages={Math.ceil(totalMessages / messagesPerPage)}
                setCurrentPage={setCurrentPage}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Message Details Modal with Email Layout */}
      <div className="modal fade" id="messageDetailsModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Message Details</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              {/* Wrap message content in the EmailLayout */}
              <EmailLayout>
                <div
                  className="global_modal_body"
                  dangerouslySetInnerHTML={{ __html: messageDetail }}
                />
              </EmailLayout>
            </div>
          </div>
        </div>
      </div>

      <ConfirmPasswordModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onSuccess={() => {}}
      />
    </MainLayout>
  );
};

export default BrowseMessages;
